export const basePrice = (product) => {
  const onSale = product.sale_price && product.sale_price > 0 && product.sale_price < product.price;
  return onSale ? product.sale_price : product.price;
};

export const unitPriceForQty = (base, tierPrices = [], qty = 1) => {
  let best = base;
  (tierPrices || []).forEach((t) => {
    if (qty >= t.min_qty && t.price < best) best = t.price;
  });
  return best;
};

export const tierRows = (product) => {
  const tiers = (product.tier_prices || []).slice().sort((a, b) => a.min_qty - b.min_qty);
  if (tiers.length === 0) return [];
  const firstMin = tiers[0].min_qty;
  const rows = [{ label: firstMin > 2 ? `De 1 a ${firstMin - 1} unidades` : "1 unidad", min: 1, price: basePrice(product) }];
  tiers.forEach((t, i) => {
    const next = tiers[i + 1];
    let label;
    if (next) {
      label = next.min_qty - 1 === t.min_qty ? `${t.min_qty} unidades` : `De ${t.min_qty} a ${next.min_qty - 1} unidades`;
    } else {
      label = `${t.min_qty} o más unidades`;
    }
    rows.push({ label, min: t.min_qty, price: t.price });
  });
  return rows;
};
